// store/modules/notifications.ts
import { Module } from 'vuex';
import { State as RootState } from '@/store';
import { BidService } from '@/services/backend/BidService';
import { getPendingBidsCountFromListings } from '@/services/backend/ListingService';
import { MessageService } from '@/services/backend/MessageService';

interface NotificationsState {
    totalListingNotifications: number;
    totalBidNotifications: number;
    totalOrderMessageNotifications: number;
    lastUpdate: number;
}

const notifications: Module<NotificationsState, RootState> = {
    namespaced: true,

    state: {
        totalListingNotifications: 0,
        totalBidNotifications: 0,
        totalOrderMessageNotifications: 0,
        lastUpdate: 0
    },

    mutations: {
        setListingNotifications(state, count: number) {
            state.totalListingNotifications = count;
        },
        setBidNotifications(state, count: number) {
            state.totalBidNotifications = count;
        },
        setOrderMessageNotifications(state, count: number) {
            state.totalOrderMessageNotifications = count;
        },
        setLastUpdate(state) {
            state.lastUpdate = Date.now();
        }
    },

    actions: {
        async fetchNotificationCounts({ state, commit }) {
            const now = Date.now();
            if (now - state.lastUpdate < 120000) {
                return;
            }

            try {
                const [listings, bids, messages] = await Promise.all([
                    getPendingBidsCountFromListings(null),
                    BidService.getPendingBidsCountFromListings(null),
                    MessageService.getConversationsToRespondToCount()
                ]);

                commit('setListingNotifications', listings);
                commit('setBidNotifications', bids);
                commit('setOrderMessageNotifications', messages);
                commit('setLastUpdate');
            } catch (error) {
                console.error('Error fetching notification counts:', error);
            }
        }
    },

    getters: {
        needsRefresh: (state) => {
            const now = Date.now();
            return now - state.lastUpdate > 120000;
        }
    }
};

export default notifications;